import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoPage from "../pages/artigo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/:slug",
    element: <ArtigoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;